import React, {useState, useEffect, useMemo} from "react";
import {SetMetaData} from './../../helper/page-title';
import useInfiniteList from "../../hooks/infinite-list";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import FilterInput from "../../components/form/filter/filter-input";
import normalizeFilters from "../../helper/filter/normalize-filter";
import {SettingDropdownUi, RowDataUi} from "../../components/form/master-table/ui-static";
import ValidationHelper from "../../helper/validation";
import {post_api_call,
        error_api_call,
        get_api_call
      } from './../../actions/action-creators/common';
import { alertResponseMessage } from "../../actions/action-creators/response";
//Modal
import ModalMaster from "../../modal/master";
import ModalMasterDetail from "../../modal/master-detail";
import FormDataHub from "../../data/formData/stakeholder";
import { roleStakeData, activeStatusOpp } from '../../data/formData/option';
const {
    masterTableFields,
    fieldNewStake,
    fieldValuesStake,
    fieldNewTeacher,
    // fieldValuesTeacher,
    fieldValidationStake,
    fieldValidationTeacher,
    fieldStakeView,
    fieldStakeViewTeach,
    fieldEditStake,
    fieldEditTeacher,
    fieldValidEditTeacher,
    fieldValidEditStake,
    //Principal & Counsellor
    fieldNewPrincipal,
    fieldValidationPrincipal
} = FormDataHub;
const masterTitle = {
    new: 'New Admin Entry',
    edit: 'Edit Admin Entry',
    detail: 'Admin Details'
};
const filterRolesByIds = (roles, allowedIds) => {
  return roles.filter(role => allowedIds.includes(role.id));
}
function StakeholderList(props){
    SetMetaData("Manage Admins", "", "");
    const [filterData, setFilterData] = useState({});
    const [modalLoader, setModalLoader] = useState({edit: false, detail: false});
    const [modalToggle, setModalToggle] = useState({new: false,
                                                    edit: false,
                                                    detail: false});
    const [masterFieldData, setMasterFieldData] = useState([]);
    // const [newEntryFields, setNewEntryFields] = useState();
    const [activeEditForm, setActiveForm] = useState("");
    // const [formDataMaster, setFormMasterData] = useState([]);
    const [errorData, setErrorData] = useState({new: [], edit: []});
    const [formNewData, setNewFormData] = useState({});
    const [formEditData, setEditFormData] = useState({});
    const [formViewData, setViewFormData] = useState([]);
    const [formUpdatedData, setUpdatedFormData] = useState({});
    const [isProcess, setIsProcess] = useState({new: false, edit: false});
    const [refreshKey, setRefreshKey] = useState(0);
    //Single Details
    const [detailedOppData, setDetailedOppData] = useState({});
    // const [isBtnDisabled, setBtnDisabled] = useState({new: true, edit: true});
    //Options Data
    const [optionData, setOptionData] = useState({
        // role_id: props.userRoleIds.includes(2)
        //           ? filterRolesByIds(roleStakeData, [3, 4, 5, 7])
        //           : (props.userRoleIds.includes(7)
        //             ? filterRolesByIds(roleStakeData, [3, 4, 5])
        //             : filterRolesByIds(roleStakeData, [3, 4])
        //           ),
        role_id: [],
        class_id: [],
        school_id: [],
        branch_id: []
    });

    const userRoleIds = useMemo(
        () => (props.userRoleIds || []).map(Number),
        [props.userRoleIds]
    );

    const { columnSettings, updateColumn } = useColumnSettings({
            id: true,
            name: true,
            role_id: true,
            school_id: true,
            branch_id: true,
            class_id: true,
            email: true,
            active_status_id: true
        });
    
    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            role_id: "id",
            school_id: "id",
            branch_id: "id",
            class_id: "id",
            active_status_id: "id"
        }),
        [filterData]
    );

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["manage_stakeholder", refreshKey],
        apiCall: payload => post_api_call("stakeholders", payload),
                limit: 100,
                extraPayload: {
                    fetch_type: "manage_stakeholder",
                    filter: normalizedFilter
                }
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    //Get Data from APIs
    const fetchSelectList = async(type, url) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'manage_user_role': {
                    // if (!userRoleIds.length) break; // ⛔ guard

                    setOptionData(prev => {
                        const optnData = { ...prev };

                        // if (userRoleIds.includes(2) || userRoleIds.includes(7)) {
                            optnData.school_id = data?.schools;
                            optnData.branch_id = data?.branches;
                            optnData.class_id  = data?.classes;
                        // } else {
                        //     optnData.class_id = data?.classes;
                        // }

                            optnData.active_status_id = activeStatusOpp;
                        return optnData;
                    });

                    break;
                  }
                    // var optnData = {...optionData};
                    // if(props.userRoleIds.includes(2)
                    //   || props.userRoleIds.includes(7)
                    // ){
                    //   optnData.school_id = data?.schools;
                    //   optnData.branch_id = data?.branches;
                    //   optnData.class_id = data?.classes;
                    // }else{
                    //   optnData.class_id = data?.classes;
                    // }
                    // optnData.role_id = props.userRoleIds.includes(2)
                    //                     ? filterRolesByIds(roleStakeData, [3, 4, 5, 7])
                    //                     : (props.userRoleIds.includes(7)
                    //                       ? filterRolesByIds(roleStakeData, [3, 4, 5])
                    //                       : filterRolesByIds(roleStakeData, [3, 4])
                    //                     );
                    // optnData.active_status_id = activeStatusOpp;
                    // setOptionData({...optnData});
                    // break;
                  default: 
              }
          }
          return {
              data
          };
      }catch(error){
        error_api_call({error: `admin|screens|stakeholder|list|fetchSelectList|${error}`});
        return {data: []};
      }
    }

    useEffect(() => {
      //Initial API Data
      // fetchStakeList();
      fetchSelectList('manage_user_role', 'dropdown-options/school-branch-class');
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    // useEffect(() => {
    //   setOptionData({
    //     ...optionData,
    //     role_id: props.userRoleIds.includes(2)
    //               ? filterRolesByIds(roleStakeData, [3, 4, 5, 7])
    //               : (props.userRoleIds.includes(7)
    //                 ? filterRolesByIds(roleStakeData, [3, 4, 5])
    //                 : filterRolesByIds(roleStakeData, [3, 4])
    //               )
    //   });
    // }, [props.userRoleIds]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!userRoleIds.length) return;

        setOptionData(prev => ({
            ...prev,
            role_id: userRoleIds.includes(2)
            ? filterRolesByIds(roleStakeData, [3, 4, 5, 7])
            : userRoleIds.includes(7)
                ? filterRolesByIds(roleStakeData, [3, 4, 5])
                : filterRolesByIds(roleStakeData, [3, 4])
        }));
    }, [userRoleIds]);// eslint-disable-line react-hooks/exhaustive-deps

    //View Data
    const loadViewModal = async(e, load_type, data, role_id) => {
      e.preventDefault();
      try{
        //Page Loading
        toggleModal(e, load_type, true, '', load_type, role_id);
        setModalLoader({...modalLoader, [load_type]: true});
        // const viewApiData = await post_api_call(`stakeholder/details/${user_id}`, {role_id});
        if(load_type === 'detail'){
          setViewFormData(role_id === 3 ? fieldStakeViewTeach : fieldStakeView);
          setDetailedOppData({...data});
        }else{
          setUpdatedFormData({});
          var apiDataEdit = {...fieldValuesStake, ...data};
          if(role_id === 3){
            if(data.admin_class_details.length > 0){
                var classIds = [];
                data.admin_class_details.forEach(d_class => {
                    classIds.push({id: d_class.class_id, class_name: d_class.class_name});
                });
                apiDataEdit.class_id = classIds;
            }
          }
          
          setEditFormData({...apiDataEdit});
        }
        setModalLoader({...modalLoader, [load_type]: false});
      }catch(error){
        error_api_call({error: `admin|stakeholder|list|loadViewModal|${error}`});
        alertResponseMessage({alert_type: 2, message: "Error Loading Data"});
      }
    }
    //Approve Toggle
    const approveToggle = async(e, type, is_active, user_id, role_id) => {
        e.preventDefault();
        try{
          // status_change
          if (window.confirm(`${is_active === 1 ? 'Deactivate' : 'Activate'} Admin?`)){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = true;
            }else{
                e.target.disabled = true;
            }
            const statusApiData = await post_api_call(`stakeholder/status-change`, {id: user_id, role_id, is_active: is_active === 2 ? 1 : 2});
            if(statusApiData.status === 200){
                // fetchStakeList();
                alertResponseMessage({alert_type: 1, message: `Admin ${is_active === 1 ? 'Deactivated' : 'Activated'} Successfully!`});
                setRefreshKey(prev => prev + 1); //RESET TABLE
            }
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          }
        }catch(error){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          error_api_call({error: `admin|stakeholder|list|approveToggle|${error}`});
        }
    }
    //Update Input
    const updateInput = (form_type, state_var_type, input_type, field, value, field_type="", form_field="", index=0) => {
      try{
          if(form_type === "filter"){
            let fields = {...filterData};
            fields[field] = value;
            setFilterData({...fields});
            return;
          }
          if(errorData[form_type].length){
            setErrorData({...errorData, [form_type]: []});
          }

          if(field === 'mobile_number'){
              if(value.length < 16){
                  value = value.replace(/[^0-9]/g, '');
              }else{
                  return false;
              }
          }else if(input_type === 'input'
              || input_type === 'textarea'
          ){
              // value = value.replace(/ /g, '');
              value = value.trimStart();
              // value = value.replace(/  /g, '');
              if(field === 'first_name'
                  || field === 'last_name'
              ){
                  value = value.replace(/[^a-zA-Z. ]/g, '')
                    .replace('  ', ' ');
              }
          }
          var updatedFormDetails = state_var_type === 'array' 
                            ? [] 
                            : state_var_type === 'object'
                                ? {}
                                : '';
          if(field_type === 'array'){
              const fieldData = form_type === 'new' ? {...formNewData} : {...formEditData};
              fieldData[form_field][index][field] = value;
              updatedFormDetails = {...fieldData};
              // setEditFormData({...fieldData});
          }else{
            updatedFormDetails = form_type === 'new' ? {...formNewData} : {...formEditData};
            updatedFormDetails[field] = value;
              // setEditFormData({
              //     ...formEditData,
              //     [field]: value
              // });
          }
          // if(field === 'show_image'){
          //   updatedFormDetails.show_image = true;
          // }
          if(form_type === 'new'){
            setNewFormData(updatedFormDetails);
            if(field === 'role_id'){
                if(value.id === 3){//Teacher
                  setMasterFieldData([{...masterFieldData[0], fields: [...fieldNewTeacher]}]);
                }else if(value.id === 7){//Admin
                  setMasterFieldData([{...masterFieldData[0], fields: [...fieldNewStake]}]);
                }else{
                  setMasterFieldData([{...masterFieldData[0], fields: [...fieldNewPrincipal]}]);
                }
            }
          }else{
            setEditFormData(updatedFormDetails);
          }
          if(form_type === 'edit'){
            setUpdatedFormData({...formUpdatedData, [field]: value});
          }
      }catch(error){
        console.error(error)
      }
    }
    // Toggle Modal
    const toggleModal = (e, modal_type, toggleState, index='', form_type='', role_id='') => {
        try{
            if(toggleState){
                e.preventDefault();
            }
            if(toggleState){
                // var data = {};
                // var heading = '';
                var legendTitle = 'Details';
                switch (form_type) {
                    case 'new':
                        setNewFormData({...fieldValuesStake});
                        setMasterFieldData([{
                          form_type: 'new',
                          label: legendTitle,
                          fields: [...fieldNewStake]
                        }]);
                        break;
                    case 'edit':
                        setMasterFieldData([{
                          form_type: 'edit',
                          label: legendTitle,
                          fields: role_id !== 3
                                  ? [...fieldEditStake]
                                  : [...fieldEditTeacher]
                        }]);
                        break;
                    // case 'detail':
                    //     // heading = 'Hub Details',
                    //     data = {...formDataMaster[index]};
                    //     break;
                    default: 
                        break;
                }
                setErrorData({...errorData, [form_type]: []});
                setActiveForm(form_type);
            }
            setModalToggle({...modalToggle, [modal_type]: toggleState});
        }catch(error){
            console.log(error)
        }
    }
    //Submit Details
    const updateStake = async(e, form_type='') => {
      try{
          e.preventDefault();
          setErrorData({...errorData, [form_type]: []});
          setIsProcess({...isProcess, [form_type]: true});
          var errorDetails = {
            new: [],
            edit: []
          };
          var apiFormData = {};
          //Validation
          var validation = [];
          var inputData = {};
          var validationRules = {};
          switch (form_type) {
              case 'new':
                inputData = {...formNewData};
                if(formNewData.role_id){
                  if(formNewData.role_id.id === 3){//Teacher
                    validationRules = fieldValidationTeacher;
                  }else if(formNewData.role_id.id === 7){//Admin
                    validationRules = fieldValidationStake;
                  }else{
                    validationRules = fieldValidationPrincipal;
                  }
                }else{
                  validationRules = fieldValidationStake;
                }
                break;
              case 'edit':
                inputData = {...formEditData};
                if(inputData.role_id === 3){//Teacher
                    validationRules = fieldValidEditTeacher;
                }else{
                    validationRules = fieldValidEditStake;
                }
                break;
              default:
          }
          validation = ValidationHelper.validation(inputData, validationRules).error;
          if(validation.length){
            errorDetails[form_type] = validation;
          }
          
          if(errorDetails[form_type].length === 0){
            if(form_type === 'edit'){
              inputData = {...formUpdatedData};
            }
            apiFormData = {
              'first_name': inputData.first_name,
              'last_name': inputData.last_name,
              'password': inputData.password,
            }

            if(form_type === 'new'){
              apiFormData.role_id = inputData.role_id.id;
              apiFormData.email = inputData.email;

              if(inputData.role_id.id === 3){//Teacher
                apiFormData.class_id = inputData.class_id.id;
              }
              if(inputData.role_id.id !== 7){
                apiFormData.school_id = inputData.school_id.id;
                apiFormData.branch_id = inputData.branch_id.id;
              }
            }
            
            if(((form_type === 'new'
                && formNewData.role_id
                && formNewData.role_id.id === 3)
                || (form_type === 'edit'
                  && formEditData.role_id === 3
                  ))
                && inputData.class_id
                && inputData.class_id.length
            ){
                //Class Id
                var classIds = [];
                inputData.class_id.forEach(class_id => {
                    classIds.push(class_id.id);
                });
                apiFormData.class_id = classIds;
            }
          }
          if(errorDetails[form_type].length > 0){
              setErrorData({...errorData, [form_type]: errorDetails[form_type]});
              setIsProcess({...isProcess, [form_type]: false});
              // setBtnDisabled({...isBtnDisabled, [form_type]: true});
          }else{
              //Send Data to Server
              var api = 'create';
              if(form_type === 'edit'){
                api = 'update';
                if(Object.keys(formUpdatedData).length === 0){
                  alertResponseMessage({alert_type: 3, message: "Nothing to Update"});
                  setIsProcess({...isProcess, [form_type]: false});
                  toggleModal('', form_type, false);
                  return;
                }else{
                  apiFormData.user_id = formEditData.id;
                }
              }              
              const updateFData = await post_api_call(`stakeholder/${api}`, apiFormData);
              if(updateFData.status === 200){
                  alertResponseMessage({alert_type: 1,
                                        message: form_type === 'new'
                                                ? "Admin Created Successfully"
                                                : "Information Updated Successfully"});
                  // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                  setIsProcess({...isProcess, [form_type]: false});
                  //Close Modal
                  toggleModal('', form_type, false);
                  // setIsLoading(true);
                  // fetchStakeList();
                  setRefreshKey(prev => prev + 1); //RESET TABLE
              }else{
                  setIsProcess({...isProcess, [form_type]: false});
                  if(typeof updateFData.message !== "undefined"){
                      setErrorData({...errorData, [form_type]: [updateFData.message]});
                  }
              }
          }
          
      }catch(error){
          console.error(error);
          setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
          setIsProcess({...isProcess, [form_type]: false});
          error_api_call({error: `admin|stakeholder|list|updateStake|${error}`});
      }
    }

    return (
        <>
        <div className="row">
          <div className="col-lg-12 text-end">
            <button className="btn btn-info mb-2" onClick={(e) => toggleModal(e, 'new', true, '', 'new')}>Add New Admin</button>
          </div>
          <InfiniteListWrapper
              dataLength={masterTableData.length}
              isLoading={isLoading}
              hasNextPage={hasNextPage}
              fetchNextPage={fetchNextPage}
              isFetchingNextPage={isFetchingNextPage}
              emptyMessage="No Record found!"
          >
              <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                      {/* SETTINGS */}
                      <SettingDropdownUi
                          checkedData={columnSettings}
                          fields={masterTableFields}
                          updateColumn= {(field, value) => updateColumn(field, value)}
                      />

                      {/* TABLE */}
                      <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                          <table className="table">
                              <thead>
                              <tr>
                                  {masterTableFields.map((col, i) => (
                                  (typeof col.accessRoleIds === "undefined" ||
                                      props.userRoleIds.some(role =>
                                      col.accessRoleIds.includes(role)
                                      )) &&
                                      columnSettings[col.field.name] && (
                                          <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                          {col.title}
                                          {col.is_searchable && (
                                              <FilterInput
                                                  formType="filter"
                                                  field={col?.field}
                                                  data={filterData}
                                                  selectOptions={
                                                      (col.field?.type === "multi-select"
                                                      || col.field?.type === "select")
                                                      ?
                                                          {[col.field?.name]: {
                                                              value: col?.option_val,
                                                              label: col?.option_label,
                                                              data: optionData[col.field?.name]
                                                          }}
                                                      :
                                                          {}
                                                      }
                                                  _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, data_type, input_type,  field, value)}
                                              />
                                          )}
                                          </th>
                                      )
                                  ))}
                                  <th>Action</th>
                              </tr>
                              </thead>

                              <tbody>
                              {isLoading ? (
                                  <tr>
                                      <td colSpan="20" className="text-center p-4">
                                          <img
                                              alt="Loader"
                                              src={require("../../assets/images/Image-Loader.gif")}
                                          />
                                      </td>
                                  </tr>
                              ) : (
                                  masterTableData.length > 0 
                                  ? (
                                      masterTableData.map((row, index) => {
                                      return (
                                          <tr
                                              key={index}
                                          >

                                              {masterTableFields.map((tbl, i) => (
                                                  (typeof tbl.accessRoleIds === "undefined" ||
                                                  props.userRoleIds.some(role =>
                                                      tbl.accessRoleIds.includes(role)
                                                  )) &&
                                                  columnSettings[tbl.field.name] && (
                                                  <td key={i}>
                                                      {/* {row[tbl.fetch_key]} */}
                                                      <RowDataUi
                                                          fetch_key={tbl.fetch_key}
                                                          data={row}
                                                          data_type={tbl.data_type ?? "text"}
                                                      />
                                                  </td>
                                                  )
                                              ))}

                                              <td className="d-flex">
                                                  <button onClick={(e) => loadViewModal(e, 'detail', row, row.role_id)} className="btn btn-sm btn-twitter" title="View Data"><i className="mdi mdi-eye"></i></button>
                                                  <button
                                                      onClick={(e) => approveToggle(e,
                                                                              'status_change',
                                                                              row.active_status_id,
                                                                              row.id,
                                                                              row.role_id)}
                                                      className={`btn btn-sm ms-2
                                                                  ${row.active_status_id === 1
                                                                      ? 'btn-danger'
                                                                      : 'btn-success'}`}
                                                      title={row.active_status_id === 1
                                                              ? 'Deactivate'
                                                              : 'Activate'}
                                                  ><i className="mdi mdi-check-outline"></i></button>
                                                  <button onClick={(e) => loadViewModal(e, 'edit', row, row.role_id)} className={`btn btn-sm ms-2 btn-inverse-info`} title="Edit Data"><i className="mdi mdi-pencil"></i></button>
                                              </td>
                                          </tr>
                                      );
                                      })
                                  )
                                  : 
                                  <tr>
                                      {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                      <td colSpan="20">
                                      <div className="no-fellow text-center mt-4">
                                          {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                          <p className="pt-4 head">{"No Record Found!"}</p>
                                      </div>
                                      </td>
                                  </tr>
                              )}
                              </tbody>
                          </table>
                      </div>
                  </div>
              </div>
          </InfiniteListWrapper>
        </div>
        {/* New Entry */}
        <ModalMaster
            isShow={modalToggle.new}
            _toggleModal={(e, state) => toggleModal(e, 'new', state)}
            modKey={activeEditForm}//new, edit
            formType={'new'}
            data={formNewData}
            title={masterTitle[activeEditForm]}
            _errorData={{...errorData}}
            _isProcess={{...isProcess}}
            // _isBtnDisabled={{...isBtnDisabled}}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
            _submitForm={(e, form_type) => updateStake(e, form_type)}
            _formData={[...masterFieldData]}
            selectOptions={{role_id:
                              {value: 'id',
                              label: 'role',
                              data: [...optionData.role_id],
                            },
                            class_id: {value: 'id',
                              label: 'class_name',
                              data: [...optionData.class_id]},
                            school_id: {value: 'id',
                              label: 'school_name',
                              data: [...optionData.school_id]},
                            branch_id: {value: 'id',
                              label: 'branch_name',
                              data: [...optionData.branch_id]}
                          }}
            // doc_url={docUrlData}
        />
        {/* View Oppo Details */}
        <ModalMasterDetail
            data={detailedOppData}
            isShow={modalToggle.detail}
            _toggleModal={(e, state) => toggleModal(e, 'detail', state)}
            loader={modalLoader.detail}
            _formData={[{label: "Detail", fields: [...formViewData]}]}
            title={"Admin Details"}
        />
        {/* Edit Details */}
        <ModalMaster
            isShow={modalToggle.edit}
            loader={modalLoader.edit}
            _toggleModal={(e, state) => toggleModal(e, 'edit', state)}
            modKey={activeEditForm}//edit, edit
            formType={'edit'}
            data={formEditData}
            title={masterTitle[activeEditForm]}
            _errorData={{...errorData}}
            _isProcess={{...isProcess}}
            // _isBtnDisabled={{...isBtnDisabled}}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, variable_type, input_type, field, value)}
            _submitForm={(e, form_type) => updateStake(e, form_type)}
            _formData={[...masterFieldData]}
            selectOptions={{
                            // school_id:
                            //   {value: 'id',
                            //   label: 'school_name',
                            //   data: [...oppSchoolOpt],
                            // },
                            class_id: {value: 'id',
                              label: 'class_name',
                              data: [...optionData.class_id]},
                          }}
            // doc_url={docUrlData}
        />
        </>
    )    
}

export default StakeholderList;